module.exports = __webpack_public_path__ + "img/kerry_logo.65038759.png";